import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SiteHeader.module.scss';
import ImageComponent from '@/components/imageComponent/ImageComponent';
import logo from '@logos/general/J-main-logo-color.png';
import { useAppContext } from '@/context/AppContext';
import { Language, SiteHeaderProps } from '@/types';

const SiteHeader: React.FC<SiteHeaderProps> = ({
  show = true,
  animated = true,
  logoHref = '/',
  theme = 'default',
}) => {
  const { language, setLanguage } = useAppContext();

  return (
    <div
      className={`${styles.header} ${theme === 'detail' ? styles.detailTheme : ''} ${
        animated ? (show ? styles.headerVisible : styles.headerHidden) : ''
      }`}
    >
      <div
        className={`${styles.logo} ${animated ? (show ? styles.logoVisible : '') : ''}`}
      >
        <Link to={logoHref}>
          <ImageComponent name="JLogo" img={logo} desc="JLogo" />
        </Link>
      </div>
      <div
        className={`${styles.languageButtons} ${animated ? (show ? styles.buttonsVisible : '') : ''}`}
      >
        <ul>
          <li
            className={`${styles.en} ${language === Language.EN ? styles.active : ''}`}
            onClick={() => setLanguage(Language.EN)}
          >
            EN
          </li>
          <li
            className={`${styles.pt} ${language === Language.PT ? styles.active : ''}`}
            onClick={() => setLanguage(Language.PT)}
          >
            PT
          </li>
        </ul>
      </div>
    </div>
  );
};

SiteHeader.displayName = 'SiteHeader';
export default SiteHeader;
